<template>
	<div>
		<div @mousemove="move" class="w3l-banner">
			<div :style="'transform: translate(' +
			(position == 'left' ? '20' : '-20') +
			'px,' +
			(position2 == 'top' ? '10' : '-10') +
			'px) scale(1.1)'
			" class="banner-image"></div>
			<div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">


			</div>
		</div>

		<div class="twoSectionBoxStyle">
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'z'">
				<div class="wow bounceInUp twoTitleT1Style">个人信息收集声明</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t" style="text-align: justify;">1. 个人数据的收集</p>
					<p style="text-align: justify;">
						本《个人信息收集声明》适用于索图科技技术有限公司（“我们”、“我方”或“本集团”）。本集团承诺确保您提供给我们的个人信息得到保护。根据香港《个人资料（私隐）条例》所确立的数据保护原则，本集团必须告知您我们将如何使用所获取的个人信息及其处理流程。
					</p>
					<p style="text-align: justify;">
						您可以选择是否向我们提供个人数据。如果您申请的产品和服务需要基于您的个人数据进行批准和/或处理，而您未能提供这些数据，本集团可能无法向您提供相关的产品和服务。</p>
					<p class="t" style="text-align: justify;">2. 收集个人信息的目的</p>
					<p style="text-align: justify;">为了我们能够开立或续期账户，建立或续期本集团提供的产品和服务，或遵守任何法律，您需要不时向本集团提供相关的个人信息。</p>
					<p class="t" style="text-align: justify;">3. 收集个人信息的目的</p>
					<p style="text-align: justify;">i. 考虑和处理产品和服务的申请； ii. 确保您保持良好的信誉； iii.
						提供和处理产品和服务的日常运营，包括但不限于在执行您的指示时确认您的身份，提供客户服务； iv. 为您设计相关服务或产品； v.
						根据地方或海外法律和监管机构或适用于本集团的行业组织发布的指引，履行有关信息存储、披露和使用的义务； vi. 协助预防或调查犯罪或潜在的犯罪活动； vii.
						营销、推广或直接促销服务和产品（详见第5节）； viii. 向您追讨债务（如有必要）； ix. 与上述相关的用途。</p>
					<p class="t" style="text-align: justify;">4. 个人信息的披露</p>
					<p style="text-align: justify;">
						本集团将对您的信息保密，但可能会将您的个人信息提供给本集团的其他成员公司以及为本集团提供服务的其他金融机构、供应商或合作伙伴（如支付、收款、结算、电信、信息技术、文件管理、法律等）。</p>
					<p style="text-align: justify;">为了提供您所需的产品或服务或完成交易，您的个人信息可能会被转移至海外公司。</p>
					<p style="text-align: justify;">
						本集团可能会不时与其他公司签订合同，为您提供所需的产品和服务。这些公司的业务通常包括或与以下服务有关：汇款服务（包括国际资金转账）、信息技术服务和文件管理。在这种情况下，本集团将确保他们遵守《个人资料（私隐）条例》，并在合同中注明此要求。
					</p>
					<p style="text-align: justify;">
						在进行信用和/或背景调查时，本集团可能会在获得您的同意后，从信用机构和中介机构获取您的个人信息，或向他们披露您的个人信息。本集团仅会提供与这些产品或服务密切相关的个人信息，并确保严格遵守保密要求。
					</p>
					<p style="text-align: justify;">
						如果本集团需要向在海外运营的外部方披露您的个人信息，我们将确保信息受到法律或合同条款的保护，并且合同中的法律和隐私原则与数据保护原则相同。</p>
					<p style="text-align: justify;">此外，本集团非常重视保护您的个人信息的义务，并且只与具有相同道德信念的供应商和业务伙伴合作。</p>
					<p class="t" style="text-align: justify;">5. 营销、推广或直接销售</p>
					<p style="text-align: justify;">本集团可能会使用您的个人数据进行直接营销，此使用需要您的同意（包括表示不反对）。请注意： i.
						未经您的同意，本集团不会将您的个人数据转移或披露给任何第三方用于直接营销目的； ii.
						本集团可能会不时将您的姓名、联系方式、产品和服务组合信息、统计数据、交易模式和行为转移或披露给本集团在香港和/或海外的其他办事处，以直接推广与本集团相关的服务和/或产品； iii.
						直接推广的服务和/或产品包括但不限于本集团当前和/或即将推出的服务和/或产品的最新信息、活动和促销优惠； iv.
						为了进行上述直接推广，本集团可能会聘请第三方数据处理器或服务提供商（包括但不限于数据公司、电信公司和信息技术公司）代表我们执行。</p>
					<p style="text-align: justify;">
						如果您明确拒绝，本集团将不会向您发送促销材料。如果您不希望本集团使用您的个人数据用于上述直接营销目的或对本集团使用您的个人数据有任何疑问，您可以随时联系我们（发送电子邮件至：compliance@suntone.com
						或邮寄至：香港鲗鱼涌英皇道728号K11 ATELIER
						5楼545室）。当您提出此类请求或查询时，应明确说明您的个人数据的详细信息。一般情况下，本集团可以在收到您的通知后14个工作日内回复或完成相关的拒收推广信息的程序。</p>
					<p class="t" style="text-align: justify;">6. 个人数据的安全性、准确性和保留</p>
					<p style="text-align: justify;">
						本集团采取合理的预防措施，以防止您的个人数据丢失、被盗用、未经授权的访问或破坏。本集团还采取合理的措施，确保我们持有的个人数据准确和完整，并且保留时间不会超过实现原始目的所需的实际时间。
					</p>
					<p class="t" style="text-align: justify;">7. 信息的访问和更正</p>
					<p style="text-align: justify;">您可以联系我们（发送电子邮件至：compliance@suntone.com 或邮寄至：香港鲗鱼涌英皇道728号K11 ATELIER
						5楼545室）查看或更正您的信息。本集团有权就处理任何访问或提供相关信息的请求收取合理费用。</p>
					<p class="t" style="text-align: justify;">8. 其他事项</p>
					<p style="text-align: justify;">
						如果您不是自然人，您应确保在您的公司董事、管理人员、股东、实益拥有者、授权签署人、雇员、中介、法律顾问、资金提供者、受益人和其他个人向您或您的代表提供与您的账户有关的个人信息之前，他们已知悉本集团个人信息收集声明中所列的详细信息。
					</p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'f'">
				<div class="wow bounceInUp twoTitleT1Style">個人信息收集聲明</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t" style="text-align: justify;">1. 個人數據的收集</p>
					<p style="text-align: justify;">
						本《個人信息收集聲明》適用於索圖科技技術有限公司（「我們」、「我方」或「本集團」）。本集團承諾確保您提供給我們的個人信息得到保護。根據香港《個人資料（私隱）條例》所確立的數據保護原則，本集團必須告知您我們將如何使用所獲取的個人信息及其處理流程。
					</p>
					<p style="text-align: justify;">
						您可以選擇是否向我們提供個人數據。如果您申請的產品和服務需要基於您的個人數據進行批準和/或處理，而您未能提供這些數據，本集團可能無法向您提供相關的產品和服務。</p>
					<p class="t" style="text-align: justify;">2. 收集個人信息的目的</p>
					<p style="text-align: justify;">為了我們能夠開立或續期賬戶，建立或續期本集團提供的產品和服務，或遵守任何法律，您需要不時向本集團提供相關的個人信息。</p>
					<p class="t" style="text-align: justify;">3. 收集個人信息的目的</p>
					<p style="text-align: justify;">i. 考慮和處理產品和服務的申請； ii. 確保您保持良好的信譽； iii.
						提供和處理產品和服務的日常運營，包括但不限於在執行您的指示時確認您的身份，提供客戶服務； iv. 為您設計相關服務或產品； v.
						根據地方或海外法律和監管機構或適用於本集團的行業組織發布的指引，履行有關信息存儲、披露和使用的義務； vi. 協助預防或調查犯罪或潛在的犯罪活動； vii.
						營銷、推廣或直接促銷服務和產品（詳見第5節）； viii. 向您追討債務（如有必要）； ix. 與上述相關的用途。</p>
					<p class="t" style="text-align: justify;">4. 個人信息的披露</p>
					<p style="text-align: justify;">
						本集團將對您的信息保密，但可能會將您的個人信息提供給本集團的其他成員公司以及為本集團提供服務的其他金融機構、供應商或合作夥伴（如支付、收款、結算、電信、信息技術、文件管理、法律等）。</p>
					<p style="text-align: justify;">為了提供您所需的產品或服務或完成交易，您的個人信息可能會被轉移至海外公司。</p>
					<p style="text-align: justify;">
						本集團可能會不時與其他公司簽訂合同，為您提供所需的產品和服務。這些公司的業務通常包括或與以下服務有關：匯款服務（包括國際資金轉賬）、信息技術服務和文件管理。在這種情況下，本集團將確保他們遵守《個人資料（私隱）條例》，並在合同中註明此要求。
					</p>
					<p style="text-align: justify;">
						在進行信用和/或背景調查時，本集團可能會在獲得您的同意後，從信用機構和中介機構獲取您的個人信息，或向他們披露您的個人信息。本集團僅會提供與這些產品或服務密切相關的個人信息，並確保嚴格遵守保密要求。
					</p>
					<p style="text-align: justify;">
						如果本集團需要向在海外運營的外部方披露您的個人信息，我們將確保信息受到法律或合同條款的保護，並且合同中的法律和隱私原則與數據保護原則相同。</p>
					<p style="text-align: justify;">此外，本集團非常重視保護您的個人信息的義務，並且只與具有相同道德信念的供應商和業務夥伴合作。</p>
					<p class="t" style="text-align: justify;">5. 營銷、推廣或直接銷售</p>
					<p style="text-align: justify;">本集團可能會使用您的個人數據進行直接營銷，此使用需要您的同意（包括表示不反對）。請註意： i.
						未經您的同意，本集團不會將您的個人數據轉移或披露給任何第三方用於直接營銷目的； ii.
						本集團可能會不時將您的姓名、聯系方式、產品和服務組合信息、統計數據、交易模式和行為轉移或披露給本集團在香港和/或海外的其他辦事處，以直接推廣與本集團相關的服務和/或產品； iii.
						直接推廣的服務和/或產品包括但不限於本集團當前和/或即將推出的服務和/或產品的最新信息、活動和促銷優惠； iv.
						為了進行上述直接推廣，本集團可能會聘請第三方數據處理器或服務提供商（包括但不限於數據公司、電信公司和信息技術公司）代表我們執行。</p>
					<p style="text-align: justify;">
						如果您明確拒絕，本集團將不會向您發送促銷材料。如果您不希望本集團使用您的個人數據用於上述直接營銷目的或對本集團使用您的個人數據有任何疑問，您可以隨時聯系我們（發送電子郵件至：compliance@suntone.com
						或郵寄至：香港鲗魚涌英皇道728號K11 ATELIER
						5樓545室）。當您提出此類請求或查詢時，應明確說明您的個人數據的詳細信息。一般情況下，本集團可以在收到您的通知後14個工作日內回復或完成相關的拒收推廣信息的程序。</p>
					<p class="t" style="text-align: justify;">6. 個人數據的安全性、準確性和保留</p>
					<p style="text-align: justify;">
						本集團采取合理的預防措施，以防止您的個人數據丟失、被盜用、未經授權的訪問或破壞。本集團還采取合理的措施，確保我們持有的個人數據準確和完整，並且保留時間不會超過實現原始目的所需的實際時間。
					</p>
					<p class="t" style="text-align: justify;">7. 信息的訪問和更正</p>
					<p style="text-align: justify;">您可以聯系我們（發送電子郵件至：compliance@suntone.com 或郵寄至：香港鲗魚涌英皇道728號K11 ATELIER
						5樓545室）查看或更正您的信息。本集團有權就處理任何訪問或提供相關信息的請求收取合理費用。</p>
					<p class="t" style="text-align: justify;">8. 其他事項</p>
					<p style="text-align: justify;">
						如果您不是自然人，您應確保在您的公司董事、管理人員、股東、實益擁有者、授權簽署人、雇員、中介、法律顧問、資金提供者、受益人和其他個人向您或您的代表提供與您的賬戶有關的個人信息之前，他們已知悉本集團個人信息收集聲明中所列的詳細信息。
					</p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'e'">

				<div class="wow bounceInUp twoTitleT1Style">PERSONAL INFORMATION COLLECTION STATEMENT</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. &nbsp;Collection of personal data</p>
					<p style="text-align: justify;">This "Personal Information Collection Statement" applies to Suntone
						Technology Co., Limited ("we", "us" or "our group"). Our group promises to ensure that the
						personal information you provide to us is protected. According to the Data Protection Principles
						established by Hong Kong's "Personal Data (Privacy) Ordinance", our group must inform you how we
						will use the personal information we have obtained and the process flow.</p>
					<p style="text-align: justify;">You can choose whether you want to provide personal data to us or
						not. If the products and services you apply for need to be approved and/or processed based on
						your personal data, and you fail to provide them, then our group may not be able to provide you
						with the relevant products and services.</p>
					<p class="t">2. &nbsp;Purpose of collecting personal information</p>
					<p style="text-align: justify;">In order for us to open or renew an account, establish or renew the
						products and services provided by our group, or comply with any law, you need to provide our
						group with relevant personal information from time to time.</p>
					<p class="t">3. &nbsp;Purpose of collecting personal information</p>
					<p>i. &nbsp;Consider and process applications for products and services;</p>
					<p>ii. Ensure that you maintain good reputation;</p>
					<p>iii. Provide and process the daily operations of products and services, including but not limited
						to confirming your identity when performing your instructions, providing customer service;</p>
					<p>iv. &nbsp;Design related services or products for you;</p>
					<p>v. &nbsp;Fulfil the obligations in relation to storage, disclosure and use of information in
						accordance with the guidelines issued by local or overseas laws and regulators or industry
						organizations applicable to our group;</p>
					<p>vi. &nbsp;Assist in preventing or investigating crimes or potential criminal activities;</p>
					<p>vii. Marketing, promotion or direct promotion of services and products (see Section 5 for
						details);</p>
					<p>viii. Recover the debt from you (if any and if necessary);</p>
					<p>ix. &nbsp;Uses related to the above.</p>
					<p class="t">4. &nbsp;Disclosure of personal information</p>
					<p style="text-align: justify;">Our group will keep your information confidential, but may provide
						your personal information to any other member companies of our group and other financial
						institutions, suppliers or partners who provide our group with services (such as payment,
						collection, settlement, telecommunication, information technology, document management, legal).
					</p>
					<p style="text-align: justify;">In order to provide the products or services you need or complete
						transactions, your personal information may be transferred to overseas companies. </p>
					<p style="text-align: justify;">Our group may from time to time contracts with other companies to
						provide you with the products and services you need. The business of such companies usually
						includes or is related to the following services: remittance services (including international
						fund transfers), information technology services and document management. In this case, our
						group will ensure that they will comply with the "Personal Data (Privacy) Ordinance" and such
						requirement will be stated in the contract.</p>
					<p style="text-align: justify;">Our group may obtain your personal information from credit agencies
						and intermediaries when conducting credit and/or background check after obtaining your consent,
						or disclose your personal information to them. Our group will only provide personal information
						that is closely related to such products or services and ensure strict compliance with
						confidentiality requirements.</p>
					<p style="text-align: justify;">If our group needs to disclose your personal information to external
						parties operating abroad, we will ensure that the information will be protected by laws or
						contract terms, and the laws and privacy principles in the contract are the same as data
						protection principles.</p>
					<p style="text-align: justify;">In addition, our group takes seriously the obligation to protect
						your personal information and will only co-operate with suppliers and business partners who have
						the same ethical beliefs as us.</p>
					<p class="t">5. &nbsp;Marketing, promotion or direct sales
					</p>
					<p style="text-align: justify;">Our group may use your personal data for direct marketing, and this
						use requires your consent (including expressing no objection). Please note that:</p>
					<p style="text-align: justify;">i. &nbsp;without your consent, our group will not transfer or
						disclose your personal data to any third party for direct marketing purposes;</p>
					<p style="text-align: justify;">ii. &nbsp;our group may transfer or disclose your name, contact
						information, product and service portfolio information, statistical data, transaction patterns
						and behaviours from time to time to our group's other offices in Hong Kong and/or overseas to
						directly promote services and/or products related to our group;</p>
					<p style="text-align: justify;">iii. directly promote services and/or products including, but are
						not limited to the latest information, activities, and promotional offers regarding the current
						and/or upcoming services and/or products of our group;</p>
					<p style="text-align: justify;">iv. &nbsp;in order to carry out the above-mentioned direct
						promotion, our group may engage third-party data processors or service providers (including but
						not limited to data companies, telecommunication companies and information technology companies)
						to perform on our behalf.</p>
					<p style="text-align: justify;">If you explicitly refuse, our group will not send you promotional
						materials. If you do not want our group to use your personal data for the above-mentioned direct
						marketing purposes or have any enquiries about our group's use of your personal data, you can
						contact our group at any time (send an email to: compliance@suntone.com or mail to: ROOM 545,
						5/F., K11 ATELIER, 728 KING'S ROAD, QUARRY BAY, HONG KONG). When you make such requests or
						inquiries, you should clearly state details of your personal data. Generally speaking, our group
						can reply or complete the relevant procedures for your refusing to receive promotional messages
						within 14 working days after your notification.</p>
					<p class="t">6. &nbsp;Security, accuracy and retention of personal data </p>
					<p style="text-align: justify;">Our group takes reasonable precautions to prevent loss,
						misappropriation, unauthorized access or destruction of your personal data. Our group also takes
						reasonable steps to ensure that the personal data held by us is accurate and complete, and the
						retention time will not exceed the actual need of the original purpose.</p>
					<p class="t">7. &nbsp;Access and correction of information</p>
					<p style="text-align: justify;">You can contact our group (send an email to: compliance@suntone.com
						or mail to: ROOM 545, 5/F., K11 ATELIER, 728 KING'S ROAD, QUARRY BAY, HONG KONG) to view or
						correct your information. Our group has the right to charge you a reasonable fee for processing
						any request for access or provision of relevant information.</p>
					<p class="t">8. &nbsp;Other matters</p>
					<p style="text-align: justify;">If you are not a natural person, you should ensure that before the
						directors, officers, shareholders, beneficial owners, authorized signatories, employees,
						mediators, legal advisers, funders, beneficiaries and other individuals of your company provide
						you or your representative with their personal information in relation to your account, you are
						aware of the details set out in our group's Personal Information Collection Statement.</p>
				</div>
			</div>

		</div>






	</div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
	name: "index",
	data: (vm) => {
		return {
			bodyW: 0,
			bodyY: 0,
			position: "",
			position2: "",
			contList: {
			},
			contType: "z",

		};
	},
	methods: {
		move(e) {
			if (e.pageX > this.bodyW / 2) {
				this.position = "right";
			} else {
				this.position = "left";
			}
			if (e.pageY > 250) {
				this.position2 = "top";
			} else {
				this.position2 = "bottom";
			}
		},
		changeTypeTitleName() {
			if (this.contType == "f") {
				document.title = "個人信息收集聲明";
			} else if (this.contType == 'e') {
				document.title = 'PERSONAL INFORMATION COLLECTION STATEMENT'
			} else {
				document.title = "个人信息收集声明";
			}
		}

	},

	mounted() {
		this.bodyW = document.body.clientWidth;
		this.bodyY = document.body.clientHeight;
		var that = this;
		this.contType = window.localStorage.getItem('language');
		that.changeTypeTitleName()
		window.addEventListener('setItemEvent', function (e) {
			if (e.key == "language") {
				that.contType = e.newValue;
				that.changeTypeTitleName()
			}
		})
		var wow = new WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 40,
			mobile: true,
			live: true,
		});
		wow.init();
		//QOFGPGRDUUMNZALE


	},
};
</script>

<style src="../assets/css/AboutUs-pc.css" scoped></style>
<style src="../assets/css/AboutUs-phone.css" scoped></style>
<style scoped>
.titleBox {
	padding-top: 0px;
}

.w3l-banner {
	height: 130px;
}

.twoTitleT2Style {
	display: block;
	max-width: 1120px;
}

p {
	text-indent: 0%;
}

.twoTitleT2Style ul li {
	text-indent: none;
}

.t {
	margin-top: 10px;
	font-weight: 700;
}

@media screen and (min-width: 801px) {
	p {
		text-indent: 0%;
	}

	.twoTitleT2Style ul li {
		text-indent: none;
	}
}
</style>
<!-- </style> -->
